import axios from 'axios';

const GenericOrganisationService = {
  search: (endpoint) => axios.get(`${endpoint}`)
};

export default GenericOrganisationService;
